function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\xF0\x9F\x92\xB3\xEF\xB8\x8F \xEC\x8B\xA0\xEC\x9A\xA9\xEC\xB9\xB4\xEB\x93\x9C",
  clipPath: "url(#clip0_780_1399)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M154.949 173.239V33.7621C154.949 23.6902 147.731 15.5254 138.827 15.5254L42.1023 15.5254C33.1982 15.5254 25.9799 23.6902 25.9799 33.7621V173.239C25.9799 183.311 33.1982 191.475 42.1023 191.475H138.827C147.731 191.475 154.949 183.311 154.949 173.239Z",
  fill: "#4592FB"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M93.4062 65.0609V48.0559C93.4062 45.1978 91.358 42.8809 88.8313 42.8809H73.7978C71.2711 42.8809 69.2228 45.1978 69.2228 48.0559V65.0609C69.2228 67.919 71.2711 70.2359 73.7978 70.2359H88.8313C91.358 70.2359 93.4062 67.919 93.4062 65.0609Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M129.251 15.5254H107.131V191.475H129.251V15.5254Z",
  fill: "#185DEE"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_780_1399"
}, /*#__PURE__*/React.createElement("rect", {
  width: 183,
  height: 207,
  fill: "white",
  transform: "translate(0.101074)"
})));

function SvgCreditcardsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 207,
    viewBox: "0 0 184 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardsvg);
export default __webpack_public_path__ + "static/media/creditcardsvg.f975bdf3.svg";
export { ForwardRef as ReactComponent };